import { Switch, Typography } from "antd";
import React from "react";
import { SwitchHelperTextStyle, SwitchLabelStyle, SwitchOptionContainer, SwitchOptionRow, SwitchStyle } from "./styles";

interface SwitchComponentProps {
	title: string;
	value?: boolean;
	style?: React.CSSProperties;
	labelStyle?: React.CSSProperties;
	onChange?: (checked: boolean) => void;
	defaultChecked?: boolean;
	disabled?: boolean;
	helperText?: string;
}

const SwitchOptionComponent: React.FC<SwitchComponentProps> = ({
	title,
	value,
	style,
	labelStyle,
	onChange,
	defaultChecked,
	disabled,
	helperText,
}) => {
	return (
		<SwitchOptionContainer>
			<Typography.Title style={labelStyle ?? SwitchLabelStyle} level={5}>
				{title}
			</Typography.Title>
			{helperText && <span style={SwitchHelperTextStyle}>({helperText})</span>}
			<SwitchOptionRow>
				<Switch
					defaultChecked={defaultChecked}
					checked={value}
					style={style ?? SwitchStyle}
					disabled={disabled}
					onChange={(checked: boolean) => onChange && onChange(checked)}
					checkedChildren="Açık"
					unCheckedChildren="Kapalı"
				/>
			</SwitchOptionRow>
		</SwitchOptionContainer>
	);
};

export default SwitchOptionComponent;
